'use client'

import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = useAuthStore((s) => s.theme)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark')
    // Tell the browser which scheme to use for native controls (<select> dropdown,
    // scrollbars, autofill). Without this, dropdowns inherit the OS theme — so a
    // user with macOS in Dark Mode sees a black dropdown even when our app is light.
    document.documentElement.style.colorScheme = theme === 'dark' ? 'dark' : 'light'
  }, [theme])

  return <>{children}</>
}
